import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import savePreparationItemConfirmDialog from '../dialog.savePreparationItemConfirmDialog';
import controller from './edit-preparation-item-dialog.controller';
import template from './edit-preparation-item-dialog.html';

/**
 * Validators
 */
import validator1, { name as validatorName1 }
  from '../messages/preparation-item.unique-name.validator.directive';
import validator2, { name as validatorName2 }
  from '../messages/preparation-item-unique-reference-number.validator.directive';

/**
 * Validation Message Templates
 */
import assignedToTpl from '../messages/preparation-item.assigned-to.messages.html';
import generalTextTpl from '../messages/preparation-item.general-text.messages.html';
import nameTpl from '../messages/preparation-item.name.messages.html';
import referenceNumberTpl from '../messages/preparation-item.reference-number.messages.html';
import statusTpl from '../messages/preparation-item.status.messages.html';

class dialogService {
  getOptions($event, {
    customerId, auditId, auditIsActive, statuses, users, preparationItem, addCallback
  }) {
    return {
      controller,
      controllerAs: 'editPreparationItemDialogVM',
      locals: {
        customerId,
        auditId,
        auditIsActive,
        statuses,
        users,
        preparationItem,
        addCallback,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editPreparationItemDialog', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  loaderService,
  savePreparationItemConfirmDialog,
  ssDialogService,
])
  .directive(validatorName1, validator1)
  .directive(validatorName2, validator2)
  .service('editPreparationItemDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('preparation-item.reference-number.messages.html', referenceNumberTpl);
    $templateCache.put('preparation-item.assigned-to.messages.html', assignedToTpl);
    $templateCache.put('preparation-item.name.messages.html', nameTpl);
    $templateCache.put('preparation-item.status.messages.html', statusTpl);
    $templateCache.put('preparation-item.general-text.messages.html', generalTextTpl);
  })
  .name;
